// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1uA_E","productName":"Table_productName__qSJ7Q"};